export default "__VITE_ASSET__DnoGHTAm__"